import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { SupplierStatusEnum } from '../enums/supplier-status.enum';
import { SupplierTypeEnum } from '../enums/supplier-type.enum';

/**
 * Supplier DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.SUPPLIER)
export class SupplierSearchDto extends BaseSearchDto {
  code!: string;
  contactShortName?: string | null;
  status!: SupplierStatusEnum;
  type!: SupplierTypeEnum;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
}
